<script lang="ts">
    import IconifyIcon from '@iconify/svelte'
    import signOutAltIcon from '@iconify/icons-fa-solid/sign-out-alt'
    import {api} from "src/services/api/reallis/index"
    import {userProfile} from 'src/services/auth'
    import {Link} from 'svelte-routing'
    import {myRole} from 'src/components/#common/myRole'

    let error
    let loading = true

    function logOut() {
        api.ws.ws1.auth.logout()
    }
</script>
<div class="navbar-custom">
    <ul class="list-unstyled topbar-menu float-end mb-0">
        <li class="notification-list">
            <Link to="profile/{$userProfile?.userId}" class="nav-link nav-user arrow-none me-0">
                <span>
                    <span class="account-user-name">{!$userProfile?.nickname ? 'Loading...' : $userProfile.nickname}</span>
                    <span class="account-position">{!$myRole?.value?.name ? 'Loading...' : $myRole.value.name}</span>
                </span>
            </Link>
        </li>
        <li class="notification-list">
            <div class="nav-link" on:click={logOut}>
                <IconifyIcon icon={signOutAltIcon} class="noti-icon"/>
            </div>
        </li>
    </ul>
    <button class="button-menu-mobile open-left">
        <i class="fas fa-bars"></i>
    </button>
</div>

<style>
    .navbar-custom {
        padding: 0 24px;
        background-color: #fff;
        -webkit-box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
        box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
        min-height: 70px;
        position: fixed;
        left: 260px;
        top: 0;
        right: 0;
        z-index: 4;
    }

    .navbar-custom .topbar-menu {
        position: relative;
        z-index: 1;
    }

    .notification-list {
        margin-left: 0;
    }

    .navbar-custom .topbar-menu li {
        float: left;
        max-height: 70px;
    }

    .navbar-custom .topbar-menu .nav-link {
        padding: 0 25px;
        color: #98a6ad;
        min-width: 32px;
        display: block;
        text-align: center;
        position: relative;
    }

    .notification-list :global(.noti-icon) {
        font-size: 22px;
        height: 70px;
    }

    .navbar-custom .topbar-menu {
        position: relative;
        z-index: 1;
    }

    .notification-list {
        margin-left: 0;
    }

    .navbar-custom .topbar-menu li {
        float: left;
        max-height: 70px;
    }

    .navbar-custom .topbar-menu .nav-link {
        padding: 0 25px;
        color: #98a6ad;
        min-width: 32px;
        display: block;
        text-align: center;
        position: relative;
        cursor: pointer;
    }

    .button-menu-mobile {
        display: none;
        border: none;
        color: #313a46;
        height: 70px;
        line-height: 70px;
        width: 70px;
        background-color: transparent;
        font-size: 24px;
        cursor: pointer;
        float: left;
        z-index: 1;
        position: relative;
        margin-left: -24px;
    }

    :global(.nav-user) {
        padding: 13px 20px !important;
        text-align: left!important;
        position: relative;
        background-color: #fafbfd;
        border: 1px solid #f1f3fa;
        border-width: 0 1px;
        min-height: 70px;
        color: #98a6ad;
    }

    :global(.nav-user:hover) {
        color: #818e94;
    }

    :global(.nav-user .account-user-name) {
        display: block;
        font-weight: 600;
        font-size: 15px;
    }

    :global(.nav-user .account-position) {
        display: block;
        font-size: 12px;
        text-align: right;
    }

    .navbar-custom .topbar-menu li:last-child {
        border-right: 1px solid #f1f3fa;
    }

    @media(max-width: 991px) {
        .navbar-custom {
            left: 0;
        }

        .nav-user .account-user-name {
            max-width: 145px;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .navbar-custom .topbar-menu .nav-link {
            padding: 0 24px;
            margin-right: -24px;
        }

        .navbar-custom .topbar-menu li:last-child {
            border-right: 0;
        }

        .navbar-custom .nav-user {
            border-left: 0;
            padding: 13px 15px !important;
        }
    }
</style>
